import barSimpleBarChart from "assets/images/chart-images/simple-chart.png";
import table from "assets/images/chart-images/table.png";
import barHorizontalBarChart from "assets/images/chart-images/horizontal-bar-chart.png";
import mapWorldMap from "assets/images/chart-images/map/map_world_map.png";

const countriesList = [
        { id: "%RIdC-BV01p", name: "simple-bar", chartImage: barSimpleBarChart, disabled: false },
        { id: "%RIdC-BH01p", name: "horizontal-bar", chartImage: barHorizontalBarChart, disabled: false },
        { id: "%RIdC-M01p", name: "line", chartImage: mapWorldMap, disabled: false },
        { id: "%RIdC-M02p", name: "line", chartImage: mapWorldMap, disabled: false },
        { id: "%RIdC-T01p", name: "table", chartImage: table, v2: "Column", disabled: false },
        { id: "%RIdC-T02p", name: "table", chartImage: table, v2: "Row", disabled: false },

        { id: "%RIdPC-BV01p", name: "simple-bar", chartImage: barSimpleBarChart, disabled: false },
        { id: "%RIdPC-BH01p", name: "horizontal-bar", chartImage: barHorizontalBarChart, disabled: false },
        { id: "%RIdPC-T01p", name: "table", chartImage: table, v2: "Column", disabled: false },
        { id: "%RIdPC-T02p", name: "table", chartImage: table, v2: "Row", disabled: false },
];

export default countriesList;

